export function renderStartupError(message: string, error: unknown): void {
  console.error(message, error);

  const root = document.querySelector('platform-shell-root');
  if (!root) return;

  const main = document.createElement('main');
  main.setAttribute('role', 'alert');
  main.style.cssText =
    'max-width:42rem;margin:4rem auto;padding:1.5rem;font-family:system-ui,sans-serif';

  const eyebrow = document.createElement('p');
  eyebrow.textContent = 'Bolão Clube';
  eyebrow.style.cssText =
    'color:#2563eb;font-weight:800;text-transform:uppercase';

  const title = document.createElement('h1');
  title.textContent = 'Não foi possível iniciar a plataforma';

  const description = document.createElement('p');
  description.textContent =
    'Atualize a página. Os produtos publicados separadamente continuam disponíveis em seus endereços próprios.';

  main.append(eyebrow, title, description);
  root.replaceChildren(main);
}
